import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogSection } from "../models/CatalogSection";

export const getCatalogSections = async (): Promise<CatalogSection[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetSections]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogSection[];
	}
	throw new Error(resp.message || "Error fetching catalog sections");
};

export const upsertCatalogSection = async (section: CatalogSection) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "SectionId", value: section.SectionId },
		{ name: "SectionName", value: section.SectionName },
		{ name: "Enabled", value: section.IsActive },
	];
	return await apiService.callV2("[FAB].[UpsertSection]", parameters);
};

export const deleteCatalogSection = async (sectionId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "SectionId", value: sectionId }];
	return await apiService.callV2("[FAB].[DeleteSection]", parameters);
};
